module.exports = __webpack_public_path__ + "static/media/blom-pysanky-48.15db7fd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-48.jpg
// module id = 3737
// module chunks = 15